import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SuccessLoginVendor = () => {
    return (
        <div className="success-login-vendor-wrapper d-flex justify-content-center">
            <div className="success-box d-flex justify-content-center align-items-center flex-column">
                <IconName name="check_circle" className="icon"/>
                <p className="text">کاربر عزیز ثبت نام شما با موفقیت انجام شد
                    بعد از تایید مدارک با شما تماس گرفته میشود</p>
            </div>
        </div>
    );
};

export default SuccessLoginVendor;
